import { memo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import dayjsPluginUTC from 'dayjs-plugin-utc';

import useStyles from './styles';

dayjs.extend(dayjsPluginUTC);

const AMEXBenefitsInfo = ({
  info: {
    title,
    shipName,
    departureDate,
    cruiseLineName,
    amenities,
    groupNumber,
    programType,
  },
}) => {
  const classes = useStyles();

  return (
    <div className="m-4">
      <span className="text-lg font-bold">
        {title}
        {' '}
        sailing on the
        {' '}
        {shipName}
        {' '}
        on
        {' '}
        {dayjs(departureDate).format('MM/DD/YYYY')}
      </span>
      <div className="grid grid-cols-10 gap-4 my-2 text-lg">
        <div className="col-span-2">Group #:</div>
        <div className="col-span-8">{groupNumber}</div>
        <div className="col-span-2">Amenities:</div>
        <div className="col-span-8">{amenities}</div>
        <div className="col-span-2">Program Type:</div>
        <div className="col-span-8">{programType}</div>
      </div>
      <ol className={classes.root}>
        <li>
          Contact
          {' '}
          {cruiseLineName}
          {' '}
          dedicated
          AmexCruis Groups phone line at 877-200-3235.
        </li>
        <li>
          Reference the main group phone number 954-331-5407
          and group code listed on the
          {' '}
          {programType}
          {' '}
          sailing list on
          AxtraWeb (or the AmexGroup number in CPMaxx.)
        </li>
        <li>
          Provide
          {' '}
          <span className="font-bold">YOUR booking phone number</span>
          {' '}
          to be added as the secondary phone number on the booking as well as your e-mail address.
        </li>
        <li>
          Confirm fare and category requested is combinable with
          {' '}
          {programType}
          {' '}
          at time of booking.
        </li>
        <li>
          Review your confirmation and verify that it has been documented with the
          {' '}
          {programType}
          {' '}
          group
        </li>
        <li>
          Coordinate all final booking details,
          dining requirements, deviations, special needs,
          and payments directly with the cruise line
        </li>
      </ol>
      <div>
        CPP is NOT combinable with
        {' '}
        {programType}
        {' '}
        when offered by
        {' '}
        {cruiseLineName}
        . Combinable with Destination Family
      </div>
    </div>
  );
};

AMEXBenefitsInfo.propTypes = {
  info: PropTypes.shape({
    title: PropTypes.string,
    shipName: PropTypes.string,
    departureDate: PropTypes.string,
    cruiseLineName: PropTypes.string,
    amenities: PropTypes.string,
    groupNumber: PropTypes.string,
    programType: PropTypes.string,
  }).isRequired,
};

export default memo(AMEXBenefitsInfo);
